export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSlevamatsk';
export const NAME = 'SlevaMaterialuSkupina';
